$(function () {
  'use strict';

  var $loginForm = $('.js-login-form');
  var $btnAuthentication = $('.js-btn-authentication');
  var $txtIdentifier = $('.js-txt-identifier');
  var $txtPassword = $('.js-txt-password');
  var currentScene = 1;

  if (!$loginForm || !$btnAuthentication || !$txtIdentifier) {
    return false;
  }

  /**
   * 入力値(メールアドレス)のチェック
   * @param identifierId  {string}  メールアドレス
   */
  function checkAuthentication() {
    var identifierId = $txtIdentifier.val();
    if (identifierId.length === 0) {
      toastr.warning('メールアドレスを入力してください。');
    } else {
      var $scene1 = $('.js-scene1'),
          $scene2 = $('.js-scene2');

      $.ajax({
        url: generateAuthMethodUrl(),
        type: 'POST',
        dataType: 'json',
        data: {identifier_id: identifierId},
      }).done(function (response) {
        if (response.auth_method === 'saml') {
          // SSO Login
          $scene1.addClass('animated fadeOutLeft');
          location.href = response.sso_url;
        } else if (response.login_id_format === 'invalid') {
          toastr.warning('メールアドレス、携帯電話番号 または TUNAG ID を正しく入力してください。');
        } else {
          // Password Login
          if (response.redirect_url) {
            location.href = response.redirect_url;
          } else {
            currentScene = 2;
            setIdentifierId(identifierId);
            changeScene($scene1, $scene2);
          }
        }
      }).fail(function () {
        console.log(generateAuthMethodUrl())
        console.log('Identifier_id check failed.');
      });
    }
  }

  /**
   * 入力されたIdentifierIdの追加
   * @param identifierId  {string}  メールアドレス
   */
  function setIdentifierId(identifierId) {
    var $lblIdentifier = $('.js-lbl-identifier');
    $lblIdentifier.html('<p class="m-b10">アカウント: <strong>' + identifierId + '</strong></p>');
  }

  function generateAuthMethodUrl() {
    if (location.pathname === '/users/sign_in') return '/users/sign_in/auth_method'
    if (location.pathname === '/multi_accounts/sign_in') return '/multi_accounts/sign_in/auth_method'
  }

  /**
   * シーン切り替え
   * @param $fromScene  {jQuery}  切り替え前
   * @param $toScene    {jQuery}  切り替え後
   */
  function changeScene($fromScene, $toScene) {
    $fromScene.addClass('animated fadeOutLeft').on('webkitAnimationEnd mozAnimationEnd oAnimationEnd oanimationend animationend', function () {
      $fromScene.addClass('hidden');
      $toScene.removeClass('hidden').addClass('animated fadeInRight');
    });
  }

  /**
   * ログインメールアドレス確認ボタン クリックイベントハンドラ
   */
  $btnAuthentication.click(function () {
    checkAuthentication();
    return false;
  });

  /**
   * Submit イベントハンドラ
   */
  $loginForm.on('submit', function () {
    // シーン1（メールアドレスの確認）
    if (currentScene === 1) {
      checkAuthentication();
      return false;
    } else if (currentScene === 2) {
      var password = $txtPassword.val();
      if (password.length === 0) {
        toastr.warning('パスワードを入力してください。');
        return false;
      }
    }
  });
});
